<template>
  <div class="row">
    <div class="col-12 mt-3 block-text">
      <div class="mb-1" v-for="(accordion, index) in accordions" :key="accordion.id">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="mb-0">{{ accordion.title }}</h6>
          <b-button
            v-b-toggle="`accordion-${accordion.id}-${index}`"
            variant="outline-secondary"
            class="rounded-circle accordion-toggle"
            @click="setActiveAccordion(accordion.id)"
          >
            <b-icon
              v-if="!checkActiveAccordion(accordion.id)"
              icon="chevron-down"
              :scale="0.6"
            ></b-icon>
            <b-icon
              v-if="checkActiveAccordion(accordion.id)"
              icon="chevron-up"
              :scale="0.6"
            ></b-icon>
          </b-button>
        </div>
        <b-collapse
          :id="`accordion-${accordion.id}-${index}`"
          :accordion="'accordion-group-' + accordion.id"
        >
          <div class="p-3">
            <vue-markdown :source="accordion.inner_text" />
          </div>
        </b-collapse>
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
  name: "AccordionBlock",
  components: { VueMarkdown },
  props: {
    accordions: Array,
    title: String,
  },
  data() {
    return {
      activeAccordions: [],
    };
  },
  methods: {
    setActiveAccordion(id) {
      if (this.activeAccordions.includes(id)) {
        this.activeAccordions = this.activeAccordions.filter((value) => value !== id);
      } else {
        this.activeAccordions.push(id);
      }
    },
    checkActiveAccordion(id) {
      return this.activeAccordions.includes(id);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .accordion-text {
  & p > img {
    width: 100%;
  }
}
.btn-outline-secondary:hover,
.btn-outline-secondary:focus {
  background: transparent;
  box-shadow: none;
  color: $color-orange;
}

.accordion-toggle {
  height: 32px;
  width: 32px;
  padding: 0.2rem 0 0 0;
  line-height: 0;
}
</style>
